import * as Thrift from 'evernote-thrift';

const originalToString = (Thrift as any).BinaryParser.toString;

(Thrift as any).BinaryParser.toString = function(dataview: any) {
  try {
    return originalToString.call(this, dataview);
  } catch (e) {
    console.log('Error decoding binary data:', e, dataview);
    return '';
  }
};
